/**
 * Périodes du décompte TVA : trimestres, semestres, année.
 */

/** Périodes de décompte : trimestres, semestres, année. */
export const PERIODES_TVA = [
  ['t1', '1er trimestre', 0, 2],
  ['t2', '2e trimestre', 3, 5],
  ['t3', '3e trimestre', 6, 8],
  ['t4', '4e trimestre', 9, 11],
  ['s1', '1er semestre', 0, 5],
  ['s2', '2e semestre', 6, 11],
  ['annee', 'Année', 0, 11],
];

const deux = (n) => String(n).padStart(2, '0');

/**
 * Premier et dernier jour d'une période de décompte.
 *
 * @param {number} annee exercice
 * @param {string} periode clé de {@link PERIODES_TVA}
 * @returns {[string, string]} bornes AAAA-MM-JJ
 */
export function bornesTva(annee, periode) {
  const p = PERIODES_TVA.find(([k]) => k === periode) || PERIODES_TVA[6];
  const dernierJour = new Date(annee, p[3] + 1, 0).getDate();
  return [`${annee}-${deux(p[2] + 1)}-01`, `${annee}-${deux(p[3] + 1)}-${deux(dernierJour)}`];
}
